import { render, staticRenderFns } from "./BookmarkFeature.vue?vue&type=template&id=2867d795"
import script from "./BookmarkFeature.vue?vue&type=script&lang=js"
export * from "./BookmarkFeature.vue?vue&type=script&lang=js"
import style0 from "./BookmarkFeature.vue?vue&type=style&index=0&id=2867d795&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports